import React from 'react'
import '../assets/style/about.css'
import { Link } from 'react-router-dom'
import { FaReact } from 'react-icons/fa'
import { SiBootstrap, SiJavascript, SiHtml5, SiNodedotjs, SiPhp, SiPostgresql, SiElementor, SiWordpress } from 'react-icons/si'
import { RiNextjsLine } from "react-icons/ri";

export default function About(){
    return (
        <>
            <div className="about">
                <div className="container-fluid p-0">
                    <div className="row p-0">
                        <div className="col-12 col-md-4 col-left text-center">
                            <div className="name">
                                <h3 className='text-center'>AJAY KUMAR</h3>
                            </div>
                            <div className="quote">
                                <h2>Ready to discuss your project?</h2>
                                <p>Let's super-charge your business today!</p>
                                <div className="btn-bg mt-32">
                                    <Link to="/contact"><button className='download-btn w-100'>Contact</button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-8 col-right">
                            <div className="row px-40">
                                <h2>I'm Specialized In</h2>
                                <h3 className="grad">Front-End Development<span className='blink'>_</span></h3>
                            </div>

                            <div className="row my-skills">
                                <h4>Front-End Developement</h4>
                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <SiHtml5 className='logo' /><span className='sk-title'>HTML/CSS</span>
                                    </div>
                                    <RatingCard filled={5} />
                                </div>
                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <SiJavascript className='logo' /><span className='sk-title'>Javascript</span>
                                    </div>
                                    <RatingCard filled={5} />
                                </div>
                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <FaReact className='logo' /><span className='sk-title'>React Js</span>
                                    </div>
                                    <RatingCard filled={5} />
                                </div>
                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <RiNextjsLine className='logo' /><span className='sk-title'>Next Js</span>
                                    </div>
                                    <RatingCard filled={5} />
                                </div>
                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <SiBootstrap className='logo' /><span className='sk-title'>Tailwind CSS</span>
                                    </div>
                                    <RatingCard filled={5} />
                                </div>
                            </div>
                            <hr className='p-0' />
                            <div className="row my-skills">
                                <h4>Back-End Developement</h4>
                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <SiNodedotjs className='logo' /><span className='sk-title'>Node Js</span>
                                    </div>
                                    <RatingCard filled={4} />
                                </div>
                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <SiPhp className='logo' /><span className='sk-title'>PHP</span>
                                    </div>
                                    <RatingCard filled={4} />
                                </div>
                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <SiPostgresql className='logo' /><span className='sk-title'>PostgreSQL</span>
                                    </div>
                                    <RatingCard filled={4} />
                                </div>
                            </div>
                            <hr className='p-0' />
                            <div className="row my-skills">
                                <h4>CMS & Website Builders</h4>

                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <SiWordpress className='logo' />
                                        <span className='sk-title'>WordPress</span>
                                    </div>
                                    <RatingCard filled={5} />
                                </div>

                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <SiElementor className='logo' />
                                        <span className='sk-title'>Elementor</span>
                                    </div>

                                    <RatingCard filled={5} />
                                </div>

                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <span className='sk-title'>WooCommerce</span>
                                    </div>

                                    <RatingCard filled={4} />
                                </div>

                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <SiWordpress className='logo' />
                                        <span className='sk-title'>Gutenberg</span>
                                    </div>

                                    <RatingCard filled={5} />
                                </div>

                                <div className="col-md-4 d-flex skill">
                                    <div className="title">
                                        <SiWordpress className='logo' />
                                        <span className='sk-title'>ACF</span>
                                    </div>

                                    <RatingCard filled={4} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row desc px-40">
                        <div className="col-12 p-0">
                            <h3 className='pt-16'><span>01.</span> ABOUT ME</h3>
                            <p className='pt-16'>
                                Hello! I'm Ajay Kumar, a Frontend and Full Stack Developer with 4 years of experience in building scalable, responsive, and user-friendly web applications. I specialize in React.js, Next.js, JavaScript, TypeScript, and WordPress development, with hands-on experience in creating modern digital products and optimizing application performance.
                            </p>
                        </div>

                        <div className="col-12 p-0">
                            <h3 className='pt-16'><span>02.</span> DEVELOPMENT & PROBLEM SOLVING</h3>
                            <p className='pt-16'>
                                I enjoy turning complex ideas into clean and efficient solutions. From building reusable UI components to integrating APIs and handling backend functionality, I focus on writing maintainable code and delivering seamless user experiences across devices and platforms.
                            </p>
                        </div>

                        <div className="col-12 p-0">
                            <h3 className='pt-16'><span>03.</span> PASSION FOR DESIGN & PERFORMANCE</h3>
                            <p className='pt-16'>
                                I believe great applications should not only work flawlessly but also provide an intuitive and visually appealing experience. I pay close attention to UI/UX, responsiveness, accessibility, and performance optimization to create products that users genuinely enjoy using.
                            </p>
                        </div>
                    </div>

                    <div className="row exp">
                        <div className="col-12 col-md-6 p-0 pe-md-5">
                            <h2 className=''>Employement</h2>
                            <div className="line"></div>
                            <div className="row ei-field">
                                <div className="col-12 col-md-8">
                                    <h4>Metanect Private Limited</h4>
                                    <p>Frontend Developer</p>
                                </div>
                                <div className="col-12 col-md-4 text-end">
                                    <p>July 2025 - May 2026</p>
                                </div>
                            </div>
                            <div className="line"></div>
                            <div className="row ei-field">
                                <div className="col-12 col-md-8">
                                    <h4>Kynet WEb Solutions</h4>
                                    <p>Web Developer</p>
                                </div>
                                <div className="col-12 col-md-4 text-end">
                                    <p>March 2022 - June 2025</p>
                                </div>
                            </div>

                        </div>
                        <div className="col-12 col-md-6 p-0 ps-md-5 edu-box">
                            <h2 className=''>Education</h2>
                            <div className="line"></div>
                            <div className="row ei-field">
                                <div className="col-12 col-md-8">
                                    <h4>BCA (Graduation)</h4>
                                    <p>VGC Mandi, HP</p>
                                </div>
                                <div className="col-12 col-md-4 text-end">
                                    <p>2018-2021</p>
                                </div>
                            </div>
                            <div className="row ei-field">
                                <div className="col-12 col-md-8">
                                    <h4>10+2</h4>
                                    <p>HPBOSE</p>
                                </div>
                                <div className="col-12 col-md-4 text-end">
                                    <p>2017-2018</p>
                                </div>
                            </div>
                            <div className="row ei-field">
                                <div className="col-12 col-md-8">
                                    <h4>Matriculation</h4>
                                    <p>HPBOSE</p>
                                </div>
                                <div className="col-12 col-md-4 text-end">
                                    <p>2015-2016</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


const RatingCard = ({ filled = 0, total = 6 }) => {
    return (
        <div className="rating d-flex">
            {[...Array(total)].map((_, index) => (
                <span
                    key={index}
                    className={`box ${index < filled ? 'filled' : ''}`}
                ></span>
            ))}
        </div>
    )
}